import fonts from './src/styles/fonts.css'
require('smooth-scroll')('a[href*="#"]')
import wrapWithProvider from './wrap-with-provider'

export const wrapRootElement = wrapWithProvider
